import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'

import { useStep } from './provider'

export const PrevBtn = () => {
	const { t } = useLingui()
	const { goToPreviousStep } = useStep()

	return (
		<Button
			size='sm'
			type='button'
			variant='ghost'
			className='flex-1'
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				goToPreviousStep()
			}}
		>
			{t`Précédent`}
		</Button>
	)
}
